import React, {useEffect} from "react";
import {registerConcersion} from "../../logic/funel/FacebookUtils";
import {getFacebookShareLink} from "../../todo/UnsorteddFunctions";

export function FaceBookShare() {
    registerConcersion('Donate');
    useEffect(() => {
        window.location.href = getFacebookShareLink();
    }, []);
    return (
        <div>
            Redirecting...
        </div>
    );
}

